import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Country } from '@wdx/portal/api-models';
import { BaseApiService } from '../base-api.service';

@Injectable({ providedIn: 'root' })
export class CountryApiService extends BaseApiService {
    getCountries(): Observable<Country[]> {
        return this._get<Country[]>('country');
    }
}
